import { useRouter } from "next/router";
import styled from "styled-components";

import { Section, Container } from "../../styles/commonStyles";
import Button from "../Buttons/Button";
import config from "../../config";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import Mixpanel from "../../utils/Mixpanel";
import { getUrlPath } from "../../utils/helpers";
import { useWindowResize } from "../../utils/hooks";

const CTABanner = ({ bgColor = "#ffffff", text, bolderText }) => {
	const router = useRouter();
	const [isMobileView] = useWindowResize();

	const trackPostJobClick = () => {
		Mixpanel.track("CTA Post a job click", {
			source: "EmployerHeader",
			page: getUrlPath(),
		});
	};

	return (
		<PrimarySection>
			<Container>
				<BannerContainer bgColor={bgColor} isMobileView={isMobileView}>
					<BannerTextWrapper>
						<BannerText>{text}</BannerText>
						{bolderText && <BannerTextInBold>{bolderText}</BannerTextInBold>}
					</BannerTextWrapper>
					<BannerActions>
						<PostJobBtn
							href={`${config.dashboardUrl}/login?utm_source=${
								(router.query && router.query.utm_source) || "Website"
							}&utm_medium=${
								(router.query && router.query.utm_medium) ||
								"Post%20Job%20Button"
							}&utm_campaign=${
								(router.query && router.query.utm_campaign) ||
								"EmployerHeader"
							}`}
							as="a"
							className="h-mobile"
							target="_blank"
							id="cta-banner-job-typeform-btn"
							rel="noopener noreferrer"
							onClick={trackPostJobClick}
						>
							Post a job
						</PostJobBtn>
					</BannerActions>
				</BannerContainer>
			</Container>
		</PrimarySection>
	);
};
// Styles
const PrimarySection = styled(Section)`
	background-color: #4d3951;
`;
const BannerContainer = styled.div`
	background-color: ${(props) => (props.bgColor ? props.bgColor : "#ffffff")};
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: ${(props) => (props.isMobileView ? "column" : "row")};
	padding: 30px;
	${mediaMaxWidth.medium`
		padding: 15px;
	`};
`;
const BannerTextWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	${mediaMaxWidth.medium`
		margin-bottom: 15px;
	`};
`;
const BannerText = styled.div`
	font-size: 32px;
	font-weight: 300;
	line-height: 1.38;
	color: #4d3951;
	${mediaMaxWidth.medium`
		font-size: 16px;
    `};
`;
const BannerTextInBold = styled.div`
	font-size: 32px;
	line-height: 1.38;
	color: #4d3951;
	font-weight: 900;
	padding-left: 5px;
	${mediaMaxWidth.medium`
		font-size: 16px;
    `};
`;
const BannerActions = styled.div``;
const PostJobBtn = styled(Button)`
	height: 32px;
	border-radius: 4px;
	background-color: #2bb793;
	font-size: 20px;
	font-weight: 900;
	color: #ffffff;
	padding: 10px 40px;
	margin-right: 12px;
	border: none;
	outline: none;
	line-height: 32px;
	text-decoration: none;
	&:hover {
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.39);
	}
	${mediaMaxWidth.medium`
		font-size: 12px;
		padding: 6px 24px;
    `};
`;
export default CTABanner;
